import React from 'react';
import { Link } from 'react-router-dom';

/** A right-hand sticky card that never scrolls away on desktop. */
const StickyCta = () => (
  <aside
    className="
      border p-3 md:p-4 rounded-2xl
      text-center md:text-left
    "
  >
    <h3 className="text-lg md:text-base font-extrabold mb-1.5 text-gray-800">
      Find the Best Hair Transplant Clinic
    </h3>

    {/* Divider */}
    <div className="w-full border-t border-gray-400 my-3" />

    <p className="text-base md:text-sm leading-snug font-light mb-4 text-gray-700">
      Take our free &amp; non-binding assessment to find the ideal clinic.
    </p>

    <Link
      to="/onboarding"
      className="
        inline-flex items-center justify-center
        w-full md:w-full
        bg-gray-900 text-white font-semibold
        py-2 rounded-md transition
        text-base md:text-xs
      "
    >
      <span>Start Now</span>
      <svg
        className="w-3 h-auto ml-1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </Link>
  </aside>
);

export default StickyCta;
